// FEAT-033: PC Seat activation (localhost:8008 + BE /pcs endpoints)
// IMP-151 AC-6: SmartDentReducer 에서 분리된 PC Seat activation 전용 slice.
// 액션타입/dispatch 불변 — SmartDentConstant 를 그대로 사용하며 reducer 라우팅만 이동.
//
// rayteamsInstalled: null=미확인 | true | false
// rayteamsUser: { userId, groupId } | null (MYLAB_AUTH_USER)
// localLicenseStatus: localhost check API 응답 전체 | null
// pcActivations: GET /voucher-license/{id}/pcs 결과
import { SmartDentConstant } from '../actions/constants/SmartDentConstant';

const initialState = {
    // FEAT-033: PC Seat activation (localhost:8008 + BE /pcs endpoints)
    rayteamsInstalled: null,
    rayteamsUser: null,
    localLicenseStatus: null,
    pcActivations: [],
    // BUG-111 / IMP-192 (2026-05-12): 누적 활성화 횟수 (rayteams record.activationcount).
    // 같은 PC 가 활성화/비활성화/재활성화 시 별도 카운트 — limit 5 검사에 사용.
    // pcActivations.length 는 현재 활성 PC 수 (revoke!==true 필터됨) 라 누적과 다름.
    activationCount: 0,
    pcActivationLoading: false,
    pcActivationError: null,
    // IMP-175: PC 권장 사양 체크 결과 — { ok, failures, measured } 또는 null (미측정/실패)
    systemSpecCheck: null,
};

export const PcActivationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SmartDentConstant.SET_RAYTEAMS_INSTALLED:
            return { ...state, rayteamsInstalled: action.installed };
        case SmartDentConstant.SET_RAYTEAMS_USER:
            return { ...state, rayteamsUser: action.rayteamsUser };
        case SmartDentConstant.SET_LOCAL_LICENSE_STATUS:
            return { ...state, localLicenseStatus: action.localLicenseStatus };
        case SmartDentConstant.GET_PC_ACTIVATIONS:
            return {
                ...state,
                pcActivations: action.pcActivations,
                activationCount: typeof action.activationCount === 'number' ? action.activationCount : 0,
                pcActivationLoading: false,
            };
        case SmartDentConstant.SET_PC_ACTIVATION_LOADING:
            return { ...state, pcActivationLoading: action.loading, pcActivationError: null };
        case SmartDentConstant.SET_PC_ACTIVATION_ERROR:
            // IMP-193 review (Minor #3): 에러 시 activationCount stale 잔존 차단.
            // pcActivations 도 함께 비워서 false-positive limit 표시 회피.
            return {
                ...state,
                pcActivationError: action.error,
                pcActivationLoading: false,
                pcActivations: [],
                activationCount: 0,
            };
        case SmartDentConstant.SET_SYSTEM_SPEC_CHECK:
            return { ...state, systemSpecCheck: action.systemSpecCheck };
        default:
            return state;
    }
};
